<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>版本记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-green" @click="newVersion">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle"
                  :cell-style="tableStyle.cellStyle" :data="versionList" border height="550">
          <el-table-column type="index" label="序号" align="center" width="40">
          </el-table-column>
          <el-table-column prop="version" align="center" label="版本号"></el-table-column>
          <el-table-column prop="remark" align="center" label="更新日志"></el-table-column>
          <el-table-column prop="packageName" align="center" label="安装包名"></el-table-column>
          <el-table-column prop="packageUrl" align="center" label="地址"></el-table-column>
          <el-table-column prop="createDate" align="center" label="更新时间" :formatter="formatDate"></el-table-column>
          <el-table-column prop="forceFlag" align="center" :index="indexMethod" label="是否强制更新">
            <template v-slot="scope">
              {{scope.row.forceFlag == '0' ? '否' :'是'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button class="list-btn" type="danger" @click="delVersion(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="40%"
        @close="versionDialogClose"
    >
      <el-form
          label-width="120px"
          class="add-role-form"
          :model="versionDialog"
          :rules="dataRule"
          ref="dialogForm"
      >
        <el-form-item label="安装包：" prop="packageName">
          <el-upload
              class="upload-demo"
              action=""
              accept=".apk"
              ref="apkUpload"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :http-request="excelUploadRequest">
            <el-button class="list-btn" type="primary">上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本号：" prop="version">
          <el-input
              v-model="versionDialog.version"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="是否强更："
            prop="forceFlag"
            :index="indexMethod"  sortable
        >
          <el-select
              v-model="versionDialog.forceFlag"
              placeholder="请选择"
              size="small"
          >
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="更新说明：" prop="remark">
          <el-input
              v-model="versionDialog.remark"
              size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  class="form-btn btn-gray" @click="closeMaterialDialog">取 消</el-button>
        <el-button  class="form-btn btn-blue" @click="saveVersion">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  components: { tableCon },
  data() {
    return {
      fileList:[],
      dialogType: 0, //0 修改页面 1 进料页面 2 新增页面
      dialogTitle: "",
      typeOptions: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      queryInfo: {

      },
      dataRule: {
        version: [
          { message: "版本号不能为空", trigger: "blur", required: true },
          {pattern:/^\d+(\.\d+)(\.\d+)$/,message:'请按照指定格式填写。例（1.0.0）',trigger:'blur'}
        ],
        forceFlag: [
          { message: "请选择是否强制更新", trigger: "blur", required: true },
        ],
        remark: [
            { message: "更新日志不能为空", trigger: "blur", required: true }
            ],
      },
      versionDialog: {
        version: "",
        remark: "",
        packageName: "",
        packageUrl: "",
        forceFlag: "",
      },
      versionList: [],
      total: 0,
      dialogVisible: false,
    };
  },
  methods: {
    formatDate(row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    closeMaterialDialog() {
      this.dialogVisible = false;
      this.$refs.apkUpload.clearFiles();
    },
    dialogInit(){
      this.versionDialog.version = "";
      this.versionDialog.remark = "";
      this.versionDialog.packageName = "";
      this.versionDialog.packageUrl = "";
    },
    versionDialogClose() {
      
    },
    newVersion() {
      this.dialogInit();
      this.dialogTitle = "新增版本";
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.apkUpload.clearFiles();
        _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getVersionList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getVersionList();
    },
    clearConditions() {
      
    },
    async getVersionList() {
      const { data: res } = await this.$http.get("version/list", {
        params: this.queryInfo,
      });
      console.log(res);
      this.versionList = res.data.list;
      this.total = res.data.total;
    },
    // 删除选中的数据字典
    async delVersion(row){
      var url = 'version/delVersion';
      const {data:res} = await this.$http.post(url,{id:row.id});
      if(res.code == 200){
        this.$message({
          type:'success',
          message:res.message
        })
      }else{
        this.$message({
          type:'warning',
          message:res.message
        })
      }
      this.getVersionList();
    },
    async saveVersion() {
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
            const { data: res } = await my.$http.post(
                "/version/saveVersion",
                my.versionDialog
            );
            if (res.code == 200) {
              my.$message({
                type: "success",
                message: res.message,
              });
              my.dialogVisible = false;
              my.getVersionList();
              my.$refs.apkUpload.clearFiles();
            } else {
              my.$message.error(res.message);
              my.$refs.apkUpload.clearFiles();
            }
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // handlePreview(file) {
    //   console.log(file);
    // },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    async excelUploadRequest(file){
      let formdata = new FormData();
      formdata.append('file', file.file)
      const {data:res} = await this.$http.post('version/importAction',formdata);
      console.log(res.data);
      if(res.code == 200){
        console.log(res.data);
        this.versionDialog.packageName = res.data.packageName;
        this.versionDialog.packageUrl = res.data.packageUrl;
      }else{
        this.$message.error(res.message);
      }

    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleOrderInfo(data){
      console.log(data)
    },
  },

  created() {
    this.getVersionList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}

</style>